import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

const Navbar: React.FC = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setMobileMenuOpen(false);
        document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileMenuOpen, location.pathname]);

    const isActive = (path: string) => {
        if (path === '/') return location.pathname === '/';
        return location.pathname.startsWith(path);
    };

    const navItems = [
        { to: '/', label: 'হোম', icon: '🏠' },
        { to: '/events', label: 'সব ম্যাচ', icon: '📋' },
        { to: '/#live', label: 'লাইভ', icon: '🔴', isHash: true },
        { to: '/#about', label: 'সম্পর্কে', icon: 'ℹ️', isHash: true },
    ];

    return (
        <nav className={styles.navbar}>
            <div className={styles.container}>
                <Link to="/" className={styles.logo}>
                    <span className={styles.logoText}>BDLINK</span>
                    <span className={styles.logoAccent}>LIVE</span>
                </Link>

                <button
                    type="button"
                    className={`${styles.mobileToggle} ${mobileMenuOpen ? styles.open : ''}`}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label={mobileMenuOpen ? 'মেনু বন্ধ' : 'মেনু খুলুন'}
                    aria-expanded={mobileMenuOpen}
                >
                    <span />
                    <span />
                    <span />
                </button>

                <ul className={`${styles.navLinks} ${mobileMenuOpen ? styles.active : ''}`}>
                    {navItems.map((item) => (
                        <li key={item.to}>
                            {item.isHash ? (
                                <a
                                    href={item.to}
                                    className={styles.navLink}
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <span className={styles.icon} aria-hidden="true">{item.icon}</span>
                                    {item.label}
                                </a>
                            ) : (
                                <Link
                                    to={item.to}
                                    className={`${styles.navLink} ${isActive(item.to) ? styles.navActive : ''}`}
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <span className={styles.icon} aria-hidden="true">{item.icon}</span>
                                    {item.label}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
            {mobileMenuOpen && (
                <button
                    type="button"
                    className={styles.overlay}
                    onClick={() => setMobileMenuOpen(false)}
                    aria-label="মেনু বন্ধ করুন"
                />
            )}
        </nav>
    );
};

export default Navbar;
